import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import PresenzeWidget from "../../widgets/PresenzeWidget";
import getLezioni from '../../services/getLezioni';
import getStudenti from '../../services/getStudenti';
import { NineCellLoading } from 'react-loadingg';
import Utils from "../../utils/utils";

export default class GestionePresenze extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    }; 
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false
    }

    this.grid = 2;

    this.pageTitle = "Gestione presenze";

    this.state = {
      isLoading: true,
    }
  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentLezione = cookies.get('currentLezione', { path: '/' });

    Utils.setAnalyticsPage('Logbook filling for lesson: ' + currentLezione + ' - ' + cookies.get('db', { path: '/' }));

    this.lezione = undefined;
    this.lezioni = await getLezioni(username, token);
    this.lezioni.forEach(l => {
      if (l.id == currentLezione){
        this.lezione = l;        
      }
    });

    this.studenti = await getStudenti(username, token);

    const splittedDate = this.lezione.data.split(' ');

    this.setState({
      materia: this.lezione.str_materia,
      insegnante: this.lezione.nome_ins + ' ' + this.lezione.cognome_ins,
      data: splittedDate[0],
      orario: splittedDate[1],
      isLoading: false,
    });
  }

  render () {

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (this.lezione == undefined) return <div />;

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
          <PageTitle title={this.pageTitle} />
          <div style={{ display: 'flex', marginLeft: 5, marginTop: -25 }}>
              <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
              <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>Da questa pagina puoi vedere e modificare il registro presenze della lezione.<br/>Clicca su <i><b>A</b></i> per segnare l'alunno come assente, su <i><b>P</b></i> per impostarlo come presente. Il campo <i>Ore differenti</i> accetta valori numerici e si intende per indicare il caso in cui uno studente abbia parzialmente seguito la lezione; inserire qui le ore effettivamente seguite.</p><br/>
          </div>

          <div><b>Docente: </b>{this.state.insegnante}</div>
          <div><b>Materia: </b>{this.state.materia}</div>
          <div><b>Data: </b>{this.state.data}</div>
          <div><b>Orario: </b>{this.state.orario}</div>


          <PresenzeWidget key={Math.random()} corsi={(this.lezione.altri_corsi + this.lezione.id_corso).split(';')} lezione={this.lezione}/>

        </LoadingOverlay>
      </>
    );
  }

}

